import React from "react" 
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { ChevronDown } from "lucide-react"
import { cn } from "lib/utils" 

export default function Dropdown({
  title,
  items,
  placeholder="Choose One",
  selected,
  selectFn,
  className=""
}:{
  title:string
  items:any[]
  placeholder?:string
  selected?:string
  selectFn?:any 
  className?:string
}){

  const handleItemClick = (item:any) => {
    console.log("click")
    if( selectFn !== undefined ){
      console.log(item)
      selectFn(item)
    } else {
      item.onClick()
    }
  }

  return (
    <Menu>
      <MenuButton 
        className={cn("pl-2 pr-2 border border-solid border-slate-700 h-8 flex justify-between items-center", className)}
      >
        <span className="whitespace-nowrap">{selected && selected?.length > 0 ? selected : placeholder}</span>
        <ChevronDown className="w-4 h-4 stroke-1" />
      </MenuButton>
      <MenuItems className="w-[var(--button-width)] mt-[2px] bg-slate-950 flex flex-col items-start border border-solid border-slate-700 rounded" anchor="bottom">
        { items.map( (item:any, idx:number) => (
          <MenuItem key={idx}>
            <button 
              className="w-full flex items-center cursor-pointer px-2 py-1 text-sm hover:bg-teal-800" 
              onClick={() => handleItemClick(item)}
            >
              {item.icon && <span className="mr-2">{item.icon}</span>}
              {item.label}
            </button>
          </MenuItem>
        ))}
      </MenuItems>
    </Menu>
  )
}